import { render, staticRenderFns } from "./OfficialHeader.vue?vue&type=template&id=d0efbf40&scoped=true"
import script from "./OfficialHeader.vue?vue&type=script&lang=ts"
export * from "./OfficialHeader.vue?vue&type=script&lang=ts"
import style0 from "./OfficialHeader.vue?vue&type=style&index=0&id=d0efbf40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0efbf40",
  null
  
)

export default component.exports